const BxfCheckmarkObj = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="4.25 7.68 6.95 10.5 11.75 5.5"/></svg>',
};

export { BxfCheckmarkObj as default };
